<template>
  <button v-if="text" class="button is-large" :class="customClasses" @click="getRow()" v-translate>
    {{ text }}
  </button>
  <i v-else-if="type==='remove'" class="btn-icon mdi mdi-delete-forever" @click="getRow()"></i>
</template>

<script>
  export default {
    name: 'button-component',
    props: {
      text: {
        type: String,
        required: false
      },
      type: {
        type: String,
        required: false
      },
      customClasses: {
        type: String,
        required: false
      },
      clickHandler: {
        type: Function,
        required: false
      },
      handlerParams: {
        type: Object,
        default: () => {}
      },
      bus: {
        type: Object,
        required: true
      }
    },
    methods: {
      getRow () {
        this.bus.$emit('findRowForChild', this)
      },
      foundRowForChild (result) {
        if (result.child === this) {
          this.clickHandler(result.row, this.handlerParams)
        }
      }
    },
    created () {
      this.clickHandler && this.bus.$on('foundRowForChild', this.foundRowForChild)
    }
  }
</script>

<style lang="sass" scoped>
  .btn-icon
    cursor: pointer
    font-size: 2rem
  .btn-icon:hover
    color: gray
  .min-width
    min-width: 10rem
  .full-width
    width: 100%
</style>
